// 替换配件
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="display:flex">
          <!-- 右边表结构 -->
          <div class="table_main" style="height: calc(100vh - -30px);">
            <vxe-grid show-overflow height="100%" :stripe="true" border="default" ref="table-m1"
                      :row-config="{height: 40}"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
        <!-- <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid :stripe="true" ref="table-m1" v-bind="gridData" show-overflow height="100%" border="default"
                    :row-config="{ isHover: true }"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
            <template #form> -->
                <div class="clearfix screen-btns">
                  <div class="fl" v-if="!currentIsSite">
                    <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                                @click="openEditDialog">新增
                    </vxe-button>
                    <vxe-button v-if="replacePartsImport" status="primary" class="button-sty" icon="el-icon-bottom"
                                @click="$refs.excelUpload.show()">导入
                    </vxe-button>
                    <vxe-button v-if="replacePartsExport" status="primary" class="button-sty" icon="el-icon-top"
                                @click="doExcle">导出
                    </vxe-button>
                  </div>
                  <div class="fl" v-else></div>
                  <div class="fr">
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                  <vxe-form-item title="配件编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.partsCode" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="配件名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.partsName" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="替换配件编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.replacePartsCode" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="替换配件名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.replacePartsName" size="small" clearable/>
                    </template>
                  </vxe-form-item>

                  <!-- <vxe-form-item title="产品大类:" field="name">
                    <template v-slot>
                      <big-item-category-select :big-category-id.sync="formData.bigCategoryId"/>
                    </template>
                  </vxe-form-item>

                  <vxe-form-item title="配件大类:" field="name">
                    <template v-slot>
                      <big-parts-category-select :big-category-id.sync="formData.bigPartsCategoryId"/>
                    </template>
                  </vxe-form-item> -->
                </vxe-form>
              </template>

              <template #picSlots="{row}">
                <el-image :preview-src-list="[row.partsPic]"
                          :fit="fit"
                          :src="row.partsPic"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
                <el-image :preview-src-list="[row.partsPic1]"
                          :fit="fit"
                          :src="row.partsPic1"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
                <el-image :preview-src-list="[row.partsPic2]"
                          :fit="fit"
                          :src="row.partsPic2"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
<!--                <el-image :preview-src-list="[row.partsPic3]"-->
<!--                          :fit="fit"-->
<!--                          :src="row.partsPic3"-->
<!--                          style="width: 40px; height: 40px"-->
<!--                >-->
<!--                  <div slot="error" class="image-slot">-->
<!--                    <i class="el-icon-picture-outline"-->
<!--                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>-->
<!--                  </div>-->
<!--                </el-image>-->
<!--                <el-image :preview-src-list="[row.partsPic4]"-->
<!--                          :fit="fit"-->
<!--                          :src="row.partsPic4"-->
<!--                          style="width: 40px; height: 40px"-->
<!--                >-->
<!--                  <div slot="error" class="image-slot">-->
<!--                    <i class="el-icon-picture-outline"-->
<!--                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>-->
<!--                  </div>-->
<!--                </el-image>-->
              </template>

              <template #replacePicSlots="{row}">
                <el-image :preview-src-list="[row.replacePartsPic]"
                          :fit="fit"
                          :src="row.replacePartsPic"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
                <el-image :preview-src-list="[row.replacePartsPic1]"
                          :fit="fit"
                          :src="row.replacePartsPic1"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
                <el-image :preview-src-list="[row.replacePartsPic2]"
                          :fit="fit"
                          :src="row.replacePartsPic2"
                          style="width: 40px; height: 40px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"
                       style="width: 40px; height: 40px;font-size: 36px;line-height: 40px;text-align: center;"></i>
                  </div>
                </el-image>
              </template>


              <template #costPriceShow="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{ row.costPrice }}</span>
              </template>

              <template #sitePriceShow="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{ row.sitePrice }}</span>
              </template>

              <!-- 一级价 -->
              <template #level1SitePriceShow="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{ row.level1SitePrice }}</span>
              </template>

              <template #replaceLevel1SitePriceShow="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{ row.replaceLevel1SitePrice }}</span>
              </template>

              <template #level2SitePriceShow="{row}">
                <span v-if="isSite">*</span>
                <span v-else>{{ row.level2SitePrice }}</span>
              </template>

              <!-- 零售价 -->
              <template #userPriceShow="{row}">
                <span>{{ row.userPrice }}</span>
              </template>
              
              <template #replaceUserPriceShow="{row}">
                <span>{{ row.replaceUserPrice }}</span>
              </template>

              <template #supplierShow="{row}">
                <span v-if="!currentIsSite">{{ row.supplier }}</span>
                <span v-else>*</span>
              </template>

              <template #warehouseNameShow="{row}">
                <span v-if="!currentIsSite">{{ row.warehouseName }}</span>
                <span v-else>*</span>
              </template>

              <template #locationNameShow="{row}">
                <span v-if="!currentIsSite">{{ row.locationName }}</span>
                <span v-else>*</span>
              </template>

              <template #safeInvShow="{row}">
                <span v-if="!currentIsSite">{{ row.safeInv }}</span>
                <span v-else>*</span>
              </template>

              <template #siteMaxQtyShow="{row}">
                <span v-if="!currentIsSite">{{ row.siteMaxQty }}</span>
                <span v-else>*</span>
              </template>

              <template #costPerDateShow="{row}">
                <span v-if="!currentIsSite">{{ row.costPerDateShow }}</span>
                <span v-else>*</span>
              </template>

              <template #checkPeriodDatesShow="{row}">
                <span v-if="!currentIsSite">{{ row.checkPeriodDates }}</span>
                <span v-else>*</span>
              </template>

              <template #pricePeriodDatesShow="{row}">
                <span v-if="!currentIsSite">{{ row.pricePeriodDates }}</span>
                <span v-else>*</span>
              </template>

              <template #orderPeriodDatesShow="{row}">
                <span v-if="!currentIsSite">{{ row.orderPeriodDatesShow }}</span>
                <span v-else>*</span>
              </template>

              <template #buyPeriodDatesShow="{row}">
                <span v-if="!currentIsSite">{{ row.buyPeriodDatesShow }}</span>
                <span v-else>*</span>
              </template>

              <!-- 分页器 -->
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!--excel 模板导入 -->
    <!-- <excel-upload
      ref="excelUpload"
      title="配件资料批量导入模板"
      url="/basic/basParts/import"
      temp-url="/admin/sys-file/local/file/basParts.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload> -->
    <excel-upload
      ref="excelUpload"
      title="替换配件导入模板"
      url="/basic/basPartsReplace/importExcel"
      temp-url="/admin/sys-file/local/file/basPartsReplaces.xlsx"
      @refreshDataList="refreshChange"
    ></excel-upload>
    <!--     @refreshDataList="refreshChange"    监听子组件的-->
  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {fetchTree} from "@/api/admin/type_tree";
import {mapGetters} from "vuex";
import {indexPageMixins, siteMixins} from "@/mixins/tabChang";
import ExcelUpload from "@/components/upload/excel";
import {doCheckExcle, doDownLoadExcle} from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import api from "@/api/projectApi";
import store from "@/store";
import BigItemCategorySelect from "@/components/formItem/bigItemCategorySelect.vue";
import BigPartsCategorySelect from "@/components/formItem/bigPartsCategorySelect.vue";
import MultiplePhotoShow from "@/components/formItem/multiplePhotoShow.vue";
import PhotoShow from "@/components/formItem/photoShow.vue";

export default {
  name: 'datum',

  mixins: [indexPageMixins, siteMixins],
  components: {
    PhotoShow,
    MultiplePhotoShow,
    BigPartsCategorySelect,
    BigItemCategorySelect,
    editView,
    pager,
    ExcelUpload
  },
  data() {
    return {
      isSite: null,

      excelUpload: false,
      // treeDataLoadUrl: '/basic/basItemCategory/getList',
      // getPageDataUrl: '/basic/basParts/getListPage',
      requestParam: {
        bigPartsCategoryId: null,
        bigCategoryId: null,
        smallCategoryId: '',
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
        replacePartsCode: '', 
        replacePartsName: '', 
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 10,  // 页面数据量
      },
      formData: {
        bigPartsCategoryId: null,
        bigCategoryId: null,
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      },
      total: 0,  // 页面总数
      showEdit: false,
      editViewDataUpdateFlag: false,
      pageSizes: [10, 20, 100],
      vxeOption: {},
      filterText: '',
      activeName: 'second',
      dataId: 0,
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      data: [],
      columns: [{type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
        {title: '配件编码', field: 'partsCode', width: 110,},
        {title: '配件名称', field: 'partsName', width: 110,},
        // {title: '配件简称', field: 'partsShortName', width: 110,},
        // {title: '配件型号', field: 'partsSpec', width: 110,},
        // {title: '适用产品型号', field: 'partsSuit', width: 110,},
        {title: '品牌', field: 'brandName', width: 110,},
        {title: '产品大类', field: 'bigCategoryName', width: 110,},
        {title: '一级价', field: 'level1SitePrice', width: 70, slots: {default: 'level1SitePriceShow'}},
        {title: '零售价', field: 'userPrice', width: 70,slots: {default: 'userPriceShow'}},
        {title: '配件图片', field: '', width: 180, slots: {default: 'picSlots'}},
        {title: '替换件编码', field: 'replacePartsCode', width: 110,},
        {title: '替换件名称', field: 'replacePartsName', width: 110,},
        // {title: '替换配件型号', field: 'replacePartsSpec', width: 110,},
        {title: '替换件图片', field: '', width: 180, slots: {default: 'replacePicSlots'}},
        // {title: '替换配件适用产品型号', field: 'replacePartsSuit', width: 110,},
        {title: '产品大类', field: 'replaceBigCategoryName', width: 110,},
        {title: '品牌', field: 'replaceBrandName', width: 110,},
        {title: '一级价', field: 'replaceLevel1SitePrice', width: 70, slots: {default: 'replaceLevel1SitePriceShow'}},
        {title: '零售价', field: 'replaceUserPrice', width: 70,slots: {default: 'replaceUserPriceShow'}},
        {title: '注意事项', field: 'precautions', width: 110,},
        // {
        //   title: '采购状态', field: 'supplyStat', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.supplyStat == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.supplyStat == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '可售状态', field: 'saleStat', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.saleStat == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.saleStat == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {title: '停供原因', field: 'disableReason', width: 110,},
        // {
        //   title: '替代配件', field: 'isReplaceParts', width: 110,
        //   slots: {
        //     default: ({row}) => {
        //       if (row.isReplaceParts == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>无替代</span>
        //           </div>
        //         ];
        //       } else if (row.isReplaceParts == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>有替代</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: 'ABC类', field: 'abcType', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.abcType == 1) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>A</span>
        //           </div>
        //         ];
        //       } else if (row.abcType == 2) {
        //         return [
        //           <div class="txt-status">
        //             <span>B</span>
        //           </div>
        //         ];
        //       } else if (row.abcType == 3) {
        //         return [
        //           <div class="txt-status">
        //             <span>C</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {title: '生效日期', field: 'usePeriod', width: 110,},
        // {title: '失效日期', field: 'lostUsePeriod', width: 110,},
        // {title: '采购价', field: 'costPrice', width: 70, slots: {default: 'costPriceShow'}},
        // {title: '出厂价', field: 'sitePrice', width: 70, slots: {default: 'sitePriceShow'}},
        
        // {title: '二级价', field: 'level2SitePrice', width: 70, slots: {default: 'level2SitePriceShow'}},
       
        // {title: '单位', field: 'unitName', width: 70,},
        // {title: '适用产品型号', field: 'partsSuit', width: 110,},
        // {title: '配件大类', field: 'bigPartsCategoryName', width: 110,},
        // {title: '配件小类', field: 'smallPartsCategoryName', width: 110,},
       
        
        // {title: '供应商名称', field: 'supplier', width: 110, slots: {default: 'supplierShow'}},
        // {title: '仓库', field: 'warehouseName', width: 110, slots: {default: 'warehouseNameShow'}},
        // {title: '库位', field: 'locationName', width: 110, slots: {default: 'locationNameShow'}},
        // {title: '安全库存', field: 'safeInv', width: 110, slots: {default: 'safeInvShow'}},
        // {title: '日预计消耗量', field: 'costPerDate', width: 110, slots: {default: 'costPerDateShow'}},
        // {title: '服务商最大库存量', field: 'siteMaxQty', width: 110, slots: {default: 'siteMaxQtyShow'}},
        // {title: '最小申请量', field: 'minApplyQty', width: 110,},
        // {title: '最大申请量', field: 'maxApplyQty', width: 110,},
        // {
        //   title: '是否自动审核', field: 'autoCheck', width: 110, slots: {
        //     default: ({row}) => {
        //       if (row.autoCheck == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.autoCheck == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '是否三包件', field: 'isSbItem', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.isSbItem == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.isSbItem == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '是否需要返厂', field: 'isNeedReturn', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.isNeedReturn == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.isNeedReturn == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '耗材物资', field: 'costMaterial', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.costMaterial == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.costMaterial == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '维修物资', field: 'costFix', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.costFix == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.costFix == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {
        //   title: '一物一码物料', field: 'qrCodeFlag', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.qrCodeFlag == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.qrCodeFlag == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>是</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {title: '保修期（按月）', field: 'guaranteePeriodMonthes', width: 100},
        // {title: '服务商共享数量', field: 'siteShareQty', width: 100},
        // {
        //   title: '是否独立包装', field: 'isSinglePackage', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.isSinglePackage == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>否</span>
        //           </div>
        //         ];
        //       } else if (row.isSinglePackage == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>否</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        // {title: '最小包装量', field: 'minPackageQty', width: 100},
        // {title: '审批周期(天)', field: 'checkPeriodDates', width: 100, },
        // {title: '延价周期(天)', field: 'pricePeriodDates', width: 100},
        // {title: '下单准备期(天)', field: 'orderPeriodDates', width: 100},
        // {title: '回货周期(天)', field: 'buyPeriodDates', width: 100},
        // {title: '采购提前期(天)', field: 'purchasePeriodDates', width: 100},
        // {
        //   title: '启用状态', field: 'usable', width: 100, slots: {
        //     default: ({row}) => {
        //       if (row.usable == 0) {
        //         return [
        //           <div class="txt-status disable">
        //             <span>禁用</span>
        //           </div>
        //         ];
        //       } else if (row.usable == 1) {
        //         return [
        //           <div class="txt-status">
        //             <span>启用</span>
        //           </div>
        //         ];
        //       }
        //     }
        //   }
        // },
        {title: '替换创建时间', field: 'createTime', width: 150},
        {title: '替换创建人', field: 'createBy', width: 110,},
        {
          width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({row}) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.openEditDialog(row.partsId);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                popper-class="tooltip-skin">
                      <i class="el-icon-edit"/>
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ],


    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },

    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },

  },
  computed: {
    ...mapGetters(["permissions"])
  },
  created() {
    const userInfo = store.getters.userInfo;
    if (userInfo.snUserId) {
      this.isSite = true;
    }
    this.replacePartsExport = this.permissions['replacePartsExport']
    this.replacePartsImport = this.permissions['replacePartsImport']
  },

  mounted() {
    // this.loadbigPartsCategoryOptions()
  },

  methods: {
    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    refreshChange() {
      this.getTableData()
    },
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // //加载配件大类
    // loadbigPartsCategoryOptions() {
    //   this.$http({
    //     url: api.basItemCategory.getBigPartsCategory,
    //     method: 'get',
    //     params: {
    //       companyId : store.getters.userInfo.tenantId
    //     }
    //   }).then(res => {
    //     this.bigCategoryOption = res.data.data
    //     console.log("bigCategoryOption",this.bigCategoryOption)
    //   })
    // },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.basPartsReplace.getListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },

    // 分页
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        console.log(data, "data.data的值")
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      });
    },

    // 树节点点击
    handleNodeClick(node, data) {
      if (data.level === 1) {
        this.requestParam.bigCategoryId = data.data.id;
        this.requestParam.smallCategoryId = '';
      } else {
        this.requestParam.smallCategoryId = data.data.id;
      }
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 搜索
    searchEvent() {
      // this.requestParam.bigPartsCategoryId = this.formData.bigPartsCategoryId
      // this.requestParam.partsCode = this.formData.partsCode
      // this.requestParam.partsName = this.formData.partsName
      // this.requestParam.partsSpec = this.formData.partsSpec
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 重置
    resetEvent() {
      this.requestParam.searchCount = false
      this.requestParam.current = 1
      this.requestParam.partsCode = ''
      this.requestParam.partsName = ''
      this.requestParam.partsSpec = ''
      this.requestParam.bigCategoryId = ''
      this.requestParam.smallCategoryId = ''
      console.log('request', this.requestParam)
      this.formData = {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      }
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },

    //导出
    doExcle() {
      // const  result =
      this.$mask.open()
      doCheckExcle(fileNames.parts).then(response => {
        if (response.data.msg == "success") {
          doDownLoadExcle("/basic/basPartsReplace/doExcel", this.requestParam).then(res => {
            this.$mask.close()
            this.$message({
              type: res.data.type,
              message: res.data.content
            });
          })
        } else {
          this.$mask.close()
          this.$message({
            type: "error",
            message: response.data.msg
          });
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.table_main {
  padding-top: 5px;
  padding-left: 0px;
  border: 1px solid #ededed;
  width: calc(100% - 0px);
  border-bottom: none;
  .el-pagination {
    padding: 2px;
  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;

    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式 记得在树里加class="tree-line"
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;
    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }

  .multiplePhotoShowClass {
    width: 40px !important;
  }
}
::v-deep.vxe-grid .vxe-body--row .vxe-body--column {
    padding:  0!important;
    line-height: 18px!important;
}
</style>
